var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.177145 1.54312C0.0864353 1.42404 0.0279324 1.27822 0.00855319 1.12291C-0.010826 0.967603 0.00972893 0.8093 0.0677873 0.666717C0.125846 0.524135 0.21898 0.403236 0.336179 0.318314C0.453378 0.233392 0.58974 0.187999 0.729145 0.1875H7.27114C7.41055 0.187999 7.54691 0.233392 7.66411 0.318314C7.78131 0.403236 7.87444 0.524135 7.9325 0.666717C7.99056 0.8093 8.01112 0.967603 7.99174 1.12291C7.97236 1.27822 7.91385 1.42404 7.82314 1.54312L4.80014 5.49075C4.70631 5.61319 4.59011 5.71144 4.45948 5.7788C4.32885 5.84617 4.18685 5.88107 4.04314 5.88112H3.95914C3.81544 5.88107 3.67344 5.84617 3.54281 5.7788C3.41217 5.71144 3.29598 5.61319 3.20214 5.49075L0.177145 1.54312Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFilter);
export default __webpack_public_path__ + "static/media/arrow-down-filter.d8c1d65ec7a4910022726ef71fa71c35.svg";
export { ForwardRef as ReactComponent };